import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { selectNodeListItems } from "../../../../redux/node/selector";
import { node } from "../../../../redux/node/action";
import { selectListItems } from "../../../../redux/library/selector";

const ManagementNexusNodes = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectNodeListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const libraryData = useSelector(selectListItems)
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', sortable: true, filter: true },
      { field: 'Description', headerName: 'Description' },
      {
                field: "NodeTypeId",
                headerName: "Node Type",
                searchField: "NodeTypeId",
                sortable: true,
                filter: true,
                filterType: "text",
                  cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.NexusNodeType
 },
            },
      { field: 'ContactPersonName', headerName: 'Person Name' },
      { field: 'ContactPhoneNumber', headerName: 'Person Number' },
    ]);
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.GlobalNexusNodeId}`)
  }

  const handleDelete = (data: any) => {
    dispatch(node.delete({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_nodes/delete`,
      entity: 'NexusNodes',
      jsonData: {
        "Context": {},
        Records: [
          {
              Id: data?.GlobalNexusNodeId
          }
        ]
      }
    })).then(() => {
      dispatch(node.list({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_nodes/fetch`,
        entity: 'NexusNodes',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }));
    });
  }

  const additionButtons: any = [
    {
      name: 'Add NexusNodes',
      callback: () => handleAdd(),
    }
  ];

  const fetchNexusARecordTypeList = () => {
    dispatch(node.list({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_nodes/fetch`,
      entity: 'NexusNodes',
      jsonData: {

        "Context": {
              },
  "Records": [
    {},
  ],
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "GlobalNexusNodeId",
        "SortOrder": "desc",

      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchNexusARecordTypeList()
  }, [pageData, pageSize])

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete}
          additionButtons={additionButtons} headingName="Nexus-Node" />
      }
    </>
  );
};

export default ManagementNexusNodes;




function selectNexusNodesListItems(state: unknown): unknown {
  throw new Error("Function not implemented.");
}

